export default __webpack_public_path__ + "static/media/qrcode.46ba9d1a.png";